"use client";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { Skeleton } from "@/components/ui/skeleton"; // Import Skeleton
import { Bar, BarChart, CartesianGrid, LabelList, XAxis } from "recharts";

const chartConfig = {
  pendaftar: { label: "Pendaftar", color: "hsl(var(--chart-1))" },
  lulus: { label: "Lulus", color: "hsl(var(--chart-2))" },
  isi: { label: "Isi UKT", color: "hsl(var(--chart-3))" },
  bayar: { label: "Bayar UKT", color: "hsl(var(--chart-4))" },
  final: { label: "Resmi", color: "hsl(var(--chart-5))" },
} satisfies ChartConfig;

export function FunnelChart({
  data,
  isLoading,
}: {
  data: any;
  isLoading: boolean;
}) {
  // Safe access to data
  const rawTotal = data?.total;

  const chartData = [
    {
      step: "Pendaftar",
      value: rawTotal?.total_pendaftar ?? 0,
      fill: "var(--color-pendaftar)",
    },
    {
      step: "Lulus Seleksi",
      value: rawTotal?.total_lulus ?? 0,
      fill: "var(--color-lulus)",
    },
    {
      step: "Isi UKT",
      value: rawTotal?.total_isi_ukt ?? 0,
      fill: "var(--color-isi)",
    },
    {
      step: "Bayar UKT",
      value: rawTotal?.total_bayar_ukt ?? 0,
      fill: "var(--color-bayar)",
    },
    {
      step: "Daftar Kembali",
      value: rawTotal?.total_daftar_kembali ?? 0,
      fill: "var(--color-final)",
    },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Funnel Penerimaan Mahasiswa</CardTitle>
        <CardDescription>
          Ringkasan proses dari pendaftaran hingga registrasi.
        </CardDescription>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          // SKELETON LOADING STATE
          // Kita buat dummy bar secara visual agar mirip chart aslinya
          <div className="flex h-[200px] w-full items-end justify-between gap-2 px-2">
            {[...Array(5)].map((_, i) => (
              <div
                key={i}
                className="flex h-full w-full flex-col justify-end gap-2"
              >
                {/* Skeleton Batang */}
                <Skeleton
                  className="w-full rounded-t-lg"
                  // Simulasi tinggi acak menurun (funnel effect) untuk visual loading yang cantik
                  style={{ height: `${100 - i * 15}%` }}
                />
                {/* Skeleton Label di bawah (XAxis) */}
                <Skeleton className="mx-auto h-4 w-12" />
              </div>
            ))}
          </div>
        ) : (
          // ACTUAL CHART
          <ChartContainer config={chartConfig} className="min-h-[200px] w-full">
            <BarChart accessibilityLayer data={chartData}>
              <CartesianGrid vertical={false} />
              <XAxis
                dataKey="step"
                tickLine={false}
                tickMargin={10}
                axisLine={false}
              />
              <ChartTooltip content={<ChartTooltipContent />} />
              <Bar dataKey="value" radius={8}>
                <LabelList
                  position="top"
                  offset={12}
                  className="fill-foreground"
                  fontSize={12}
                />
              </Bar>
            </BarChart>
          </ChartContainer>
        )}
      </CardContent>
    </Card>
  );
}
